module.exports = __webpack_public_path__ + "img/order-created.3f1dd6a6.png";